import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private permissions: { [key: string]: { item: string; view: number; enable: number; required: number } } = {};

  constructor(private http: HttpClient) {}

  loadPermissions(rolId: number): Promise<void> {
    // Verificar que el rolId sea válido
    if (!rolId || rolId === 0) {
      this.permissions = {};
      return Promise.resolve();
    }

    // Determinar la ruta base de los permisos según el environment
    const permissionsPath = environment.clientType === 'invergran'
      ? 'assets/permissions_Invergran/rol' 
      : 'assets/permissions/rol';

    return this.http
      .get<{ data: any[] }>(permissionsPath + rolId + '.json')
      .toPromise()
      .then((response) => {
        const permisosArray = response.data || [];

        this.permissions = permisosArray.reduce((acc, curr) => {
          acc[curr.codigo] = {
            item: curr.item,
            view: curr.view,
            enable: curr.enable,
            required: curr.required
          };
          return acc;
        }, {} as { [key: string]: { item: string; view: number; enable: number; required: number } });
      })
      .catch((error) => {
        console.error('Error al cargar permisos para rol', rolId, ':', error);
        this.permissions = {};
      });
  }

  getPermission(uid: string): { item: string; view: number; enable: number; required: number } {
    return this.permissions[uid] || { item: '', view: 0, enable: 0, required: 0 };
  }

  /**
   * Verifica y recupera el rol del usuario si se ha perdido
   */
  verifyAndRecoverRol(): number {
    let rol = sessionStorage.getItem('p9sh2');
    
    if (!rol || rol === '0') {
      // Intentar recuperar el rol de los datos de usuario
      const userData = sessionStorage.getItem('user');
      
      if (userData) {
        try {
          const decryptedUser = JSON.parse(userData.replace(/['"]+/g, ''));
          
          if (decryptedUser && decryptedUser.rolId) {
            rol = decryptedUser.rolId.toString();
            sessionStorage.setItem('p9sh2', rol);
          }
        } catch (error) {
          console.error('Error al recuperar rol desde datos de usuario:', error);
        }
      }
    }
    
    return rol ? parseInt(rol, 10) : 0;
  }

  /**
   * Carga permisos verificando primero la persistencia del rol
   */
  loadPermissionsWithRecovery(): Promise<void> {
    const rolId = this.verifyAndRecoverRol();
    if (rolId > 0) {
      return this.loadPermissions(rolId);
    } else {
      this.permissions = {};
      return Promise.resolve();
    }
  }
}
